import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/home';
import Login from '@/pages/login/login';



Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/404',
            name: '404',
            component: resolve => require(['@/pages/component/404.vue'],resolve),
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            children: [
                { //主页面
                    path: '/dashed',
                    name: 'dashed',
                    component: resolve => require(['@/pages/component/dashed.vue'], resolve),
                    meta: []
                },
                {
                    path: '/suffAgree',
                    name: 'payagreement',
                    component: resolve => require(['@/pages/component/payAgreement.vue'], resolve),
                    meta: ['患者告知']
                },
                {
                    //模块列表
                    path: '/module',
                    name: 'module',
                    component: resolve => require(['@/pages/component/module.vue'], resolve),
                    meta: ['权限配置','后台模块列表']
                },
                {
                    //角色权限 ===> role_list 角色权限   account ===》 账号管理
                    path: '/role/:id',
                    name: 'role',
                    component: resolve => require(['@/pages/component/role.vue'], resolve),
                    meta:['权限配置','角色权限']
                },
                {
                    //治疗师账号管理
                    path: '/nurse',
                    name: 'nurse',
                    component: resolve => require(['@/pages/component/nurse.vue'], resolve),
                    meta:['医护管理','治疗师账号管理']
                },
                {
                    //治疗师认证审核
                    path: '/nurse_certification',
                    name: 'nurse_certification',
                    component: resolve => require(['@/pages/component/nurse_certification.vue'], resolve),
                    meta: ['医护管理','治疗师认证审核']
                },
                {
                    //治疗师签名录入
                    path: '/nurse_signature',
                    name: 'nurse_signature',
                    component: resolve => require(['@/pages/component/nurse_signature.vue'], resolve),
                    meta: ['医护管理','治疗师签名录入'],
                },
                {
                    //调度员管理
                    path: '/scheduling',
                    name: 'scheduling',
                    component: resolve => require(['@/pages/component/scheduling.vue'], resolve),
                    meta: ['医护管理','调度员管理']
                },
                {
                    //患者账号管理
                    path: '/patient',
                    name: 'patient',
                    component: resolve => require(['@/pages/component/patient.vue'], resolve),
                    meta: ['患者管理','患者账号管理']
                },
                {
                    //患者认证审核
                    path: '/patient_',
                    name: 'patient_',
                    component: resolve => require(['@/pages/component/patient_.vue'], resolve),
                    meta: ['患者管理','患者认证审核']
                },
                {
                    //报警超时时间
                    /*

                        实例： /timeout/timer

                        timer => 报警超时
                        host => 家庭协议设置
                        service => 服务须知
                        money => 保险费用
                        consumables => 耗材费用
                        treatment => 治疗费用管理
                        remote => 远程协助管理费
                        traffic => 交通管理
                        hospital => 医院管理
                    */
                    path: '/timeout/:name',
                    name: 'timeout',
                    component: resolve => require(['@/pages/component/timeout.vue'], resolve),
                    meta: ['基础设置']
                },
                {
                  // 服务时间设置
                  path: '/serviceTime',
                  name: 'serviceTime',
                  component: resolve => require(['@/pages/component/serviceTime.vue'],resolve),
                  meta:['服务时间设置']
              },
                {
                    //服务分类
                    path: '/service_type',
                    name: 'service_type',
                    component: resolve => require(['@/pages/component/service_type.vue'],resolve),
                    meta:['服务分类','服务类型']
                },
                {
                    //服务录入
                    path: '/service_entry',
                    name: 'service_entry',
                    component: resolve => require(['@/pages/component/service_entry.vue'],resolve),
                    meta: ['服务分类','服务录入']
                },
                {
                    //服务评价
                    path: '/service_evaluation',
                    name: 'service_evaluation',
                    component: resolve => require(['@/pages/component/service_evaluation.vue'],resolve),
                    meta: ['服务分类','服务评价']
                },
                {
                    //评价列表
                    path: '/evaluation_list',
                    name: 'evaluation_list',
                    component: resolve => require(['@/pages/component/evaluation_list.vue'],resolve),
                    meta: ['服务分类','服务评价','评价列表']
                },
                {
                    //订单管理
                    path: '/order_management',
                    name: 'order_management',
                    component: resolve => require(['@/pages/component/order_management.vue'],resolve),
                    meta: ['订单管理','订单管理']

                },
                {
                    //地图监控
                    path: '/order_map',
                    name: '/order_map',
                    component: resolve => require(['@/pages/component/order_map.vue'],resolve),
                    meta: ['订单管理','地图监控']
                },
                {
                    //系统维护 ==》 banner管理
                    path: '/banner',
                    name: 'banner',
                    component: resolve => require(['@/pages/component/banner.vue'],resolve),
                    meta: ['系统维护','banner管理']
                },
                {
                    //意见反馈
                    path: '/feedback',
                    name:'feedback',
                    component: resolve => require(['@/pages/component/feedback.vue'],resolve),
                    meta: ['系统维护','意见反馈']
                },
                {
                    //投诉处理
                    path: '/complaints',
                    name: 'complaints',
                    component: resolve => require(['@/pages/component/complaints.vue'],resolve),
                    meta: ['系统维护','投诉处理']
                },
                {
                    //关于我们
                    path: '/about',
                    name: 'about',
                    component: resolve => require(['@/pages/component/about.vue'],resolve),
                    meta: ['系统维护','关于我们']
                },
                {
                    //平台收款码
                    path: '/code',
                    name: 'code',
                    component: resolve => require(['@/pages/component/code.vue'],resolve),
                    meta:['系统维护','平台收款码']
                },
                {
                    //日志
                    path: '/log',
                    name: 'log',
                    component: resolve => require(['@/pages/component/log.vue'],resolve),
                    meta: ['系统维护','日志']
                },
                {
                    //订单收入统计
                    path: '/order_income',
                    name: 'order_income',
                    component: resolve => require(['@/pages/component/order_income.vue'],resolve),
                    meta: ['财务管理','订单收入统计']
                },
                {
                    //明细
                    path: '/money_detail',
                    name: 'money_detail',
                    component: resolve => require(['@/pages/component/money_detail.vue'],resolve),
                    meta: ['财务管理','明细']
                },
                {
                    //分成比例设置
                    path: '/proportion',
                    name: 'proportion',
                    component: resolve => require(['@/pages/component/proportion.vue'],resolve),
                    meta: ['分成比例设置']
                },
                {
                    //收入结算
                    path: '/revenue',
                    name: 'revenue',
                    component: resolve => require(['@/pages/component/revenue.vue'],resolve),
                    meta: ['收入结算']
                },
                {
                    //结算
                    path: '/revenue_detail',
                    name: 'revenue_detail',
                    component: resolve => require(['@/pages/component/revenue_detail.vue'],resolve),
                    meta: ['分成比例设置','结算']
                },
                {
                    //常规交通和远距离交通
                    path: '/expense',
                    name: 'expense',
                    component: resolve => require(['@/pages/component/expense.vue'],resolve),
                    meta: ['常规交通费用 | 远距离交通费用']
                },
                {
                    //服务名称
                    path: '/service_name',
                    name: 'service_name',
                    component: resolve => require(['@/pages/component/service_name.vue'], resolve),
                    meta: ['服务名称']
                },
                {
                    //添加产品
                    path: '/template/:id/:type/:name',
                    name: 'template',
                    component: resolve => require(['@/pages/component/template.vue'], resolve),
                    meta: ['添加产品']
                },
                { path: '/*', redirect: '/404' }

            ]
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js